import { Questionnaire } from '@lib/types';
import { createReducer, on } from '@ngrx/store';
import * as FeedbackActions from '@store/actions/feedback.actions';
import produce from 'immer';

export const feedbackFeatureKey = 'feedback';

export interface State {
  questionnaire: Questionnaire | null;
  submitedQuestonnaireAverageRatting: number | null;
  submitedQuestonnaireId: number | null;
}

export const initialState: State = {
  questionnaire: null,
  submitedQuestonnaireAverageRatting: null,
  submitedQuestonnaireId: null,
};

export const reducer = createReducer(
  initialState,

  on(FeedbackActions.loadQuestionnaire, state => state),
  on(FeedbackActions.loadQuestionnaireSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.questionnaire = action.questionnaire;

      if (action.questionnaire?.alreadySubmited) {
        draftState.submitedQuestonnaireId = action.questionnaire?.id ?? 0;
        draftState.submitedQuestonnaireAverageRatting = action.questionnaire?.averageRatting ?? 0;
      }
    });
  }),
  on(FeedbackActions.loadQuestionnaireFailure, (state, action) => state),
  on(FeedbackActions.submitQuestionnaireSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.submitedQuestonnaireId = action.submissionId;
      draftState.submitedQuestonnaireAverageRatting = action.averageRatting;
    });
  }),

);
